// Thu Mar 27 06:04:37 GMT 2025

import * as models from "../crm-web-api-models"

export enum WithdrawalRequestProp {
	ApprovedAmount = 'approvedAmount',
	ApprovedCurrency = 'approvedCurrency',
	AssignedPoolId = 'assignedPool.id',
	AssignedPoolName = 'assignedPool.name',
	AssignedUser = 'assignedUser',
	Auth3D = 'auth3D',
	BonusAmount = 'bonusAmount',
	CancelledPendingDeposit = 'cancelledPendingDeposit',
	CreatedBy = 'createdBy',
	CreationTime = 'creationTime',
	CurrencyConvRate = 'currencyConvRate',
	Description = 'description',
	Id = 'id',
	MethodType = 'methodType',
	ModificationTime = 'modificationTime',
	OperationStatus = 'operationStatus',
	PaymentDetails = 'paymentDetails',
	PlatformReason = 'platformReason',
	Postponed = 'postponed',
	PostponedTill = 'postponedTill',
	Priority = 'priority',
	ProcessingType = 'processingType',
	RequestedAmount = 'requestedAmount',
	RequestedCurrency = 'requestedCurrency',
	Status = 'status',
	TotalSourceAmount = 'totalSourceAmount',
	TradingAccount = 'tradingAccount',
	TradingAccountCurrency = 'tradingAccount.currency',
	TradingAccountCustomer = 'tradingAccount.customer',
	TradingAccountCustomerId = 'tradingAccount.customer.id',
	TradingAccountAmount = 'tradingAccountAmount'
}

export type WithdrawalRequestPropApprovedAmount = {
	[WithdrawalRequestProp.ApprovedAmount] : number | null
}
export type WithdrawalRequestPropApprovedCurrency = {
	[WithdrawalRequestProp.ApprovedCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type WithdrawalRequestPropAssignedPoolId = {
	[WithdrawalRequestProp.AssignedPoolId] : number | null
}
export type WithdrawalRequestPropAssignedPoolName = {
	[WithdrawalRequestProp.AssignedPoolName] : string | null
}
export type WithdrawalRequestPropAssignedUser = {
	[WithdrawalRequestProp.AssignedUser] : any /* Entity */
}
export type WithdrawalRequestPropAuth3D = {
	[WithdrawalRequestProp.Auth3D] : boolean | null
}
export type WithdrawalRequestPropBonusAmount = {
	[WithdrawalRequestProp.BonusAmount] : number | null
}
export type WithdrawalRequestPropCancelledPendingDeposit = {
	[WithdrawalRequestProp.CancelledPendingDeposit] : boolean | null
}
export type WithdrawalRequestPropCreatedBy = {
	[WithdrawalRequestProp.CreatedBy] : models.UserDto
}
export type WithdrawalRequestPropCreationTime = {
	[WithdrawalRequestProp.CreationTime] : number | null
}
export type WithdrawalRequestPropCurrencyConvRate = {
	[WithdrawalRequestProp.CurrencyConvRate] : number | null
}
export type WithdrawalRequestPropDescription = {
	[WithdrawalRequestProp.Description] : string | null
}
export type WithdrawalRequestPropId = {
	[WithdrawalRequestProp.Id] : number
}
export type WithdrawalRequestPropMethodType = {
	[WithdrawalRequestProp.MethodType] : any /* Entity */
}
export type WithdrawalRequestPropModificationTime = {
	[WithdrawalRequestProp.ModificationTime] : number | null
}
export type WithdrawalRequestPropOperationStatus = {
	[WithdrawalRequestProp.OperationStatus] : string | null
}
export type WithdrawalRequestPropPaymentDetails = {
	[WithdrawalRequestProp.PaymentDetails] : string | null
}
export type WithdrawalRequestPropPlatformReason = {
	[WithdrawalRequestProp.PlatformReason] : string | null
}
export type WithdrawalRequestPropPostponed = {
	[WithdrawalRequestProp.Postponed] : boolean | null
}
export type WithdrawalRequestPropPostponedTill = {
	[WithdrawalRequestProp.PostponedTill] : number | null
}
export type WithdrawalRequestPropPriority = {
	[WithdrawalRequestProp.Priority] : 'HIGH' | 'MEDIUM' | 'LOW' | null
}
export type WithdrawalRequestPropProcessingType = {
	[WithdrawalRequestProp.ProcessingType] : 'MANUAL' | 'AUTO' | null
}
export type WithdrawalRequestPropRequestedAmount = {
	[WithdrawalRequestProp.RequestedAmount] : number | null
}
export type WithdrawalRequestPropRequestedCurrency = {
	[WithdrawalRequestProp.RequestedCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type WithdrawalRequestPropStatus = {
	[WithdrawalRequestProp.Status] : 'NEW' | 'APPROVED' | 'COMPLETED' | 'REJECTED' | 'CANCELED' | 'FUNDS_REMOVED' | 'PENDING_FUNDS_REMOVAL' | 'PENDING_CANCELLATION' | null
}
export type WithdrawalRequestPropTotalSourceAmount = {
	[WithdrawalRequestProp.TotalSourceAmount] : number | null
}
export type WithdrawalRequestPropTradingAccount = {
	[WithdrawalRequestProp.TradingAccount] : any /* Entity */
}
export type WithdrawalRequestPropTradingAccountCurrency = {
	[WithdrawalRequestProp.TradingAccountCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type WithdrawalRequestPropTradingAccountCustomer = {
	[WithdrawalRequestProp.TradingAccountCustomer] : any /* Entity */
}
export type WithdrawalRequestPropTradingAccountCustomerId = {
	[WithdrawalRequestProp.TradingAccountCustomerId] : number | null
}
export type WithdrawalRequestPropTradingAccountAmount = {
	[WithdrawalRequestProp.TradingAccountAmount] : number | null
}


export type WithdrawalRequest = 
	WithdrawalRequestPropApprovedAmount & 
	WithdrawalRequestPropApprovedCurrency & 
	WithdrawalRequestPropAssignedPoolId & 
	WithdrawalRequestPropAssignedPoolName & 
	WithdrawalRequestPropAssignedUser & 
	WithdrawalRequestPropAuth3D & 
	WithdrawalRequestPropBonusAmount & 
	WithdrawalRequestPropCancelledPendingDeposit & 
	WithdrawalRequestPropCreatedBy & 
	WithdrawalRequestPropCreationTime & 
	WithdrawalRequestPropCurrencyConvRate & 
	WithdrawalRequestPropDescription & 
	WithdrawalRequestPropId & 
	WithdrawalRequestPropMethodType & 
	WithdrawalRequestPropModificationTime & 
	WithdrawalRequestPropOperationStatus & 
	WithdrawalRequestPropPaymentDetails & 
	WithdrawalRequestPropPlatformReason & 
	WithdrawalRequestPropPostponed & 
	WithdrawalRequestPropPostponedTill & 
	WithdrawalRequestPropPriority & 
	WithdrawalRequestPropProcessingType & 
	WithdrawalRequestPropRequestedAmount & 
	WithdrawalRequestPropRequestedCurrency & 
	WithdrawalRequestPropStatus & 
	WithdrawalRequestPropTotalSourceAmount & 
	WithdrawalRequestPropTradingAccount & 
	WithdrawalRequestPropTradingAccountCurrency & 
	WithdrawalRequestPropTradingAccountCustomer & 
	WithdrawalRequestPropTradingAccountCustomerId & 
	WithdrawalRequestPropTradingAccountAmount

export const WITHDRAWAL_REQUEST_PROPERTY_NAMES = Object.freeze([WithdrawalRequestProp.ApprovedAmount, WithdrawalRequestProp.ApprovedCurrency, WithdrawalRequestProp.AssignedPoolId, WithdrawalRequestProp.AssignedPoolName, WithdrawalRequestProp.AssignedUser, WithdrawalRequestProp.Auth3D, WithdrawalRequestProp.BonusAmount, WithdrawalRequestProp.CancelledPendingDeposit, WithdrawalRequestProp.CreatedBy, WithdrawalRequestProp.CreationTime, WithdrawalRequestProp.CurrencyConvRate, WithdrawalRequestProp.Description, WithdrawalRequestProp.Id, WithdrawalRequestProp.MethodType, WithdrawalRequestProp.ModificationTime, WithdrawalRequestProp.OperationStatus, WithdrawalRequestProp.PaymentDetails, WithdrawalRequestProp.PlatformReason, WithdrawalRequestProp.Postponed, WithdrawalRequestProp.PostponedTill, WithdrawalRequestProp.Priority, WithdrawalRequestProp.ProcessingType, WithdrawalRequestProp.RequestedAmount, WithdrawalRequestProp.RequestedCurrency, WithdrawalRequestProp.Status, WithdrawalRequestProp.TotalSourceAmount, WithdrawalRequestProp.TradingAccount, WithdrawalRequestProp.TradingAccountCurrency, WithdrawalRequestProp.TradingAccountCustomer, WithdrawalRequestProp.TradingAccountCustomerId, WithdrawalRequestProp.TradingAccountAmount])

export type WithdrawalRequestTab = 
	WithdrawalRequestPropId & 
	WithdrawalRequestPropTradingAccountCustomerId & 
	WithdrawalRequestPropTradingAccountCustomer & 
	WithdrawalRequestPropRequestedAmount & 
	WithdrawalRequestPropRequestedCurrency

export const WITHDRAWAL_REQUEST_TAB_PROPERTY_NAMES = Object.freeze([WithdrawalRequestProp.Id, WithdrawalRequestProp.TradingAccountCustomerId, WithdrawalRequestProp.TradingAccountCustomer, WithdrawalRequestProp.RequestedAmount, WithdrawalRequestProp.RequestedCurrency])

export type WithdrawalRequestHeader = 
	WithdrawalRequestPropId & 
	WithdrawalRequestPropTradingAccountCustomerId & 
	WithdrawalRequestPropTradingAccountCustomer & 
	WithdrawalRequestPropRequestedAmount & 
	WithdrawalRequestPropRequestedCurrency & 
	WithdrawalRequestPropTradingAccount

export const WITHDRAWAL_REQUEST_HEADER_PROPERTY_NAMES = Object.freeze([WithdrawalRequestProp.Id, WithdrawalRequestProp.TradingAccountCustomerId, WithdrawalRequestProp.TradingAccountCustomer, WithdrawalRequestProp.RequestedAmount, WithdrawalRequestProp.RequestedCurrency, WithdrawalRequestProp.TradingAccount])

export type WithdrawalRequestInformation = 
	WithdrawalRequestPropId & 
	WithdrawalRequestPropTradingAccountCustomerId & 
	WithdrawalRequestPropTradingAccountCustomer & 
	WithdrawalRequestPropRequestedAmount & 
	WithdrawalRequestPropRequestedCurrency & 
	WithdrawalRequestPropTradingAccount & 
	WithdrawalRequestPropCreationTime & 
	WithdrawalRequestPropCreatedBy & 
	WithdrawalRequestPropModificationTime & 
	WithdrawalRequestPropMethodType & 
	WithdrawalRequestPropCancelledPendingDeposit & 
	WithdrawalRequestPropAuth3D

export const WITHDRAWAL_REQUEST_INFORMATION_PROPERTY_NAMES = Object.freeze([WithdrawalRequestProp.Id, WithdrawalRequestProp.TradingAccountCustomerId, WithdrawalRequestProp.TradingAccountCustomer, WithdrawalRequestProp.RequestedAmount, WithdrawalRequestProp.RequestedCurrency, WithdrawalRequestProp.TradingAccount, WithdrawalRequestProp.CreationTime, WithdrawalRequestProp.CreatedBy, WithdrawalRequestProp.ModificationTime, WithdrawalRequestProp.MethodType, WithdrawalRequestProp.CancelledPendingDeposit, WithdrawalRequestProp.Auth3D])

export type WithdrawalRequestStatus = 
	WithdrawalRequestPropPriority & 
	WithdrawalRequestPropStatus & 
	WithdrawalRequestPropProcessingType & 
	WithdrawalRequestPropPostponed & 
	WithdrawalRequestPropPostponedTill & 
	WithdrawalRequestPropAssignedPoolName & 
	WithdrawalRequestPropAssignedPoolId & 
	WithdrawalRequestPropAssignedUser

export const WITHDRAWAL_REQUEST_STATUS_PROPERTY_NAMES = Object.freeze([WithdrawalRequestProp.Priority, WithdrawalRequestProp.Status, WithdrawalRequestProp.ProcessingType, WithdrawalRequestProp.Postponed, WithdrawalRequestProp.PostponedTill, WithdrawalRequestProp.AssignedPoolName, WithdrawalRequestProp.AssignedPoolId, WithdrawalRequestProp.AssignedUser])

export type WithdrawalRequestDetails = 
	WithdrawalRequestPropStatus & 
	WithdrawalRequestPropMethodType & 
	WithdrawalRequestPropPaymentDetails & 
	WithdrawalRequestPropDescription

export const WITHDRAWAL_REQUEST_DETAILS_PROPERTY_NAMES = Object.freeze([WithdrawalRequestProp.Status, WithdrawalRequestProp.MethodType, WithdrawalRequestProp.PaymentDetails, WithdrawalRequestProp.Description])

export type WithdrawalRequestAmount = 
	WithdrawalRequestPropStatus & 
	WithdrawalRequestPropApprovedAmount & 
	WithdrawalRequestPropApprovedCurrency & 
	WithdrawalRequestPropTotalSourceAmount & 
	WithdrawalRequestPropTradingAccountAmount & 
	WithdrawalRequestPropTradingAccountCurrency & 
	WithdrawalRequestPropCurrencyConvRate & 
	WithdrawalRequestPropOperationStatus & 
	WithdrawalRequestPropBonusAmount & 
	WithdrawalRequestPropPlatformReason

export const WITHDRAWAL_REQUEST_AMOUNT_PROPERTY_NAMES = Object.freeze([WithdrawalRequestProp.Status, WithdrawalRequestProp.ApprovedAmount, WithdrawalRequestProp.ApprovedCurrency, WithdrawalRequestProp.TotalSourceAmount, WithdrawalRequestProp.TradingAccountAmount, WithdrawalRequestProp.TradingAccountCurrency, WithdrawalRequestProp.CurrencyConvRate, WithdrawalRequestProp.OperationStatus, WithdrawalRequestProp.BonusAmount, WithdrawalRequestProp.PlatformReason])

export type WithdrawalRequestCreate = 
	WithdrawalRequestPropTradingAccountCustomerId

export const WITHDRAWAL_REQUEST_CREATE_PROPERTY_NAMES = Object.freeze([WithdrawalRequestProp.TradingAccountCustomerId])
